import React, { useMemo } from "react";
import { DateTime } from "ts-luxon";
import moment from "moment-jalaali";

const PERSIAN_MONTHS = [
  "فروردین", "اردیبهشت", "خرداد",
  "تیر", "مرداد", "شهریور",
  "مهر", "آبان", "آذر",
  "دی", "بهمن", "اسفند"
];

interface PersianDateDisplayProps {
  date: DateTime;
  showDay?: boolean;
  showMonthAsNumber?: boolean;
}

const PersianDateDisplay: React.FC<PersianDateDisplayProps> = ({ date, showDay = false, showMonthAsNumber = false }) => {
  const formattedDate = useMemo(() => {
    moment.loadPersian({ usePersianDigits: false });
  
    const persianDate = moment(date.toISO()).format("jYYYY/jM/jD");
  
    const [persianYear, persianMonth, persianDay] = persianDate.split("/").map(Number);
  
    return showDay 
      ? `${persianDay} ${showMonthAsNumber ? persianMonth : PERSIAN_MONTHS[persianMonth - 1]}` 
      : `${showMonthAsNumber ? persianMonth : PERSIAN_MONTHS[persianMonth - 1]}`; 
  }, [date, showDay, showMonthAsNumber]);
  

  return <span>{formattedDate}</span>;
};

export default React.memo(PersianDateDisplay);
